import { MapPin, Globe } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BRAND, FOOTER } from "@/data/content";

const ICONS = [MapPin, Globe];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-white border-t border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-24">
        <Reveal className="max-w-3xl">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] leading-tight">
            {FOOTER.closing}
          </h2>
          <p className="text-lg font-light text-[#525252] leading-relaxed mt-6">
            {FOOTER.closingText}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-16">
          {FOOTER.columns.map((col, i) => {
            const Icon = ICONS[i];
            return (
              <div key={col.title} data-testid={`footer-col-${i}`} className="flex items-start gap-4">
                <Icon className="w-5 h-5 text-[#E60000] mt-1 shrink-0" strokeWidth={1.75} />
                <div>
                  <p className="text-xs font-bold text-[#A3A3A3] uppercase tracking-[0.15em]">
                    {col.title}
                  </p>
                  <p className="text-base font-medium text-[#0A0A0A] mt-1">{col.value}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="border-t border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt={BRAND.name} className="h-10 w-auto object-contain" />
          </div>
          <p className="text-xs text-[#A3A3A3] text-center md:text-right max-w-xl">
            {BRAND.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
